// extracted by mini-css-extract-plugin
export default {"dropdown":"Layers_dropdown__4W1ra","message":"Layers_message__kpsCn"};